import trim from 'lodash/trim';
import React, { CSSProperties, FC } from 'react';
import { PlcColor } from '@styles/colors';
import { formatNumberWithComma } from '@utils/number';
import { ChartDataSets, ChartPoint } from 'chart.js';
import styles from './ChartTooltip.module.scss';

export type ChartTooltipColors = {
  [index: number]: CSSProperties['backgroundColor'];
};

interface Props {
  title: string;
  index: number;
  datasets: ChartDataSets[];
  unit?: string;
  colors?: ChartTooltipColors;
}

export const ChartTooltip: FC<Props> = ({ title, index, datasets, unit = '', colors = {} }) => {
  const datasetsToDisplay = datasets.filter(dataset => Boolean(dataset.data && dataset.data[index]));
  return (
    <div className={styles.chartTooltip}>
      <p className={styles.textTitleTooltip}>{title}</p>
      <table>
        <tbody>
          {datasetsToDisplay.map((dataset, datasetIndex) => {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const data = dataset.data![index]! as number | ChartPoint;
            const value = typeof data === 'number' ? data : data.y;

            // Need the typeof check to avoid filtering 0
            if (typeof value === 'undefined') {
              return null;
            }

            const borderColor = typeof dataset.borderColor === 'string' ? dataset.borderColor : PlcColor.BLUE_LAND;
            const color = colors[datasetIndex] ? colors[datasetIndex] : borderColor;
            const formatedValue = typeof value === 'number' ? formatNumberWithComma(value, 1) : value;

            return (
              <tr key={dataset.label}>
                <th>
                  <span className={styles.textTooltip} style={{ color }}>
                    {dataset.label}
                  </span>
                </th>
                <td align="right">
                  <span className={styles.textTooltip} style={{ color }}>
                    {trim(`${formatedValue} ${unit}`)}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
